module.exports = __webpack_public_path__ + "img/my-profile.4c0993d1.svg";